import * as React from 'react';
import cx from 'classnames';
import { pageTypes } from 'constants/pageTypes';
import styles from './header.css';
import RichNavigation from 'components/RichNavigation/RichNavigation';
import renderWithLoadable from 'utils/withLoadable';
const NavMenuComponent = () => import(/* webpackChunkName: "NavMenu" */ 'components/Header/NavMenuNew/NavMenu');
const LoadableNavMenu = renderWithLoadable(NavMenuComponent, 'navMenu', 'NavMenu-bundle-error');
export class NavMenuContainer extends React.PureComponent {
    render() {
        const { isGrocery, pageType, disableNavMenu, showRichNav = false } = this.props;
        const isTextOnly = (isGrocery && pageType !== pageTypes.StoreLanding) || false;
        const finalClassName = cx(styles['nav-container'], {
            [styles['grocery']]: !isTextOnly && (isGrocery || showRichNav),
            [styles['grocery-text']]: isTextOnly
        });
        let navMenu = null;
        // Always prefer the grocery check. Check whether we should render the
        // optimized nav menu only when this check fails.
        if (isGrocery || showRichNav) {
            navMenu = (<RichNavigation navContainerClassName={finalClassName} containerClassName={styles['nav-menu']} isTextOnly={isTextOnly} wid=""/>);
        }
        else {
            if (disableNavMenu) {
                return null;
            }
            navMenu = (<div className={finalClassName}>
					<LoadableNavMenu containerClassName={styles['nav-menu']}/>
				</div>);
        }
        return navMenu;
    }
}
